import { render, staticRenderFns } from "./RuleActionCampaign.vue?vue&type=template&id=6b800030"
import script from "./RuleActionCampaign.vue?vue&type=script&lang=js"
export * from "./RuleActionCampaign.vue?vue&type=script&lang=js"
import style0 from "./RuleActionCampaign.vue?vue&type=style&index=0&id=6b800030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports